import { Box, Input, Label } from 'theme-ui';

const CustomMonthSelect = ({ value, colorMode, search, handleSearch, monthsList, checkMonthSelected, handleMonthSelect, handleAllMonthSelect, monthKey, checkAllMonthSelect, flagValue, checkSearchExist, loading }: { value: any, search: any, handleSearch: any, monthsList: any, checkMonthSelected: any, handleMonthSelect: any, handleAllMonthSelect: any, monthKey: string, checkAllMonthSelect: any, colorMode?: string, flagValue: string, checkSearchExist: any, loading: boolean }) => {
    const bgFilter = colorMode === 'light' ? "#ffffff" : "#323c56";
    const titleHeader = colorMode === 'light' ? "#000" : "#dadada";
    const isSearchExist = checkSearchExist();

    return (
        <div>
            <Box sx={{ position: 'absolute', gap: '8px', right: 0, zIndex: 1, backgroundColor: bgFilter, color: titleHeader, boxShadow: '0px 0px 16px rgba(0,0,0,0.06)', borderRadius: '4px', fontSize: '15px', padding: "8px" }}>
                <Box>
                    <Box sx={{ display: "flex", gap: "8px", padding: "5px" }}>
                        <input type='checkbox' checked={checkAllMonthSelect()} onChange={() => !loading && handleAllMonthSelect(monthKey, flagValue, monthsList, isSearchExist)} style={{ cursor: "pointer" }} />
                        <Input name='search' placeholder={`Enter ${monthKey === "progressionMonths" ? "month" : monthKey}`} sx={{ width: "250px", height: "30px", border: "1px solid rgba(141, 141, 141, 0.2)", backgroundColor: "#fff", color: 'black', }} value={search} onChange={!loading && handleSearch} />
                    </Box>
                    <Box sx={{ maxHeight: "200px", overflowY: "scroll" }}>
                        {monthsList?.map((month: string) => (
                            <Label key={month} className="text-hover" sx={{
                                cursor: "pointer", padding: '5px', backgroundColor: bgFilter, color: titleHeader,
                                '&:hover': {
                                    backgroundColor: colorMode === 'light' ? '#f5f5f5' : '#333333'
                                }
                            }}>
                                <input type='checkbox' checked={checkMonthSelected(month)} onChange={() => !loading && handleMonthSelect(monthKey, month, flagValue)} style={{ cursor: "pointer" }} />
                                {month}
                            </Label>
                        ))}
                    </Box>
                </Box>
            </Box>
        </div>
    )
}

export default CustomMonthSelect
